import React from 'react'
import { formatMoney } from './helpers'
import styles from './StatCards.module.scss'

/** The design's three DashboardBox stat tiles, rebuilt with the app's own
 *  card styling (--rv2-* tokens) instead of the mock's raw component import. */

interface StatCardsProps {
  reconciledCount: number
  pendingCount: number
  totalAmount: number
  absorbedAmount: number
  returnedCount: number
  returnedAmount: number
  loading?: boolean
  /** A refetch is in flight: the values shown belong to the previous filter. */
  updating?: boolean
}

const StatCard: React.FC<{
  title: string
  description: string
  value: string
  loading?: boolean
  updating?: boolean
}> = ({ title, description, value, loading, updating }) => (
  <div className={`${styles.card}${updating ? ` ${styles.updating}` : ''}`}>
    <span className={styles.title}>{title}</span>
    <span className={styles.value}>{loading ? '—' : value}</span>
    <span className={styles.description}>{description}</span>
  </div>
)

const StatCards: React.FC<StatCardsProps> = ({
  reconciledCount,
  pendingCount,
  totalAmount,
  absorbedAmount,
  returnedCount,
  returnedAmount,
  loading,
  updating,
}) => (
  <div className={styles.grid} aria-busy={updating}>
    <StatCard
      title="Reconciled"
      description="Transactions matching filters"
      value={reconciledCount.toLocaleString('en-US')}
      loading={loading}
      updating={updating}
    />
    <StatCard
      title="Pending"
      description="Not yet reconciled"
      value={pendingCount.toLocaleString('en-US')}
      loading={loading}
      updating={updating}
    />
    <StatCard
      title="Total amount"
      description="Sum of filtered transactions (excl. returned)"
      value={formatMoney(totalAmount)}
      loading={loading}
      updating={updating}
    />
    <StatCard
      title="Absorbed"
      description="Company-absorbed write-offs"
      value={formatMoney(absorbedAmount)}
      loading={loading}
      updating={updating}
    />
    <StatCard
      title="Returned"
      description={`${formatMoney(returnedAmount)} excluded from totals`}
      value={returnedCount.toLocaleString('en-US')}
      loading={loading}
      updating={updating}
    />
  </div>
)

export default StatCards
